import React from 'react'

import cert_it from './img/CompanyDocs/cert_it.jpg'
import residentTP from './img/CompanyDocs/residentTP.jpg'

const CompanyDocsPage: React.FC = () => {
    return (
        <div className="flex flex-col w-[1200px] h-full p-10 rounded-3xl gap-10 items-center justify-center mb-10">
            <div className="flex flex-col w-full text-left text-[32px] font-semibold uppercase leading-9">
                Информация о компании
            </div>
            <div className="flex flex-row w-full h-full gap-10 items-center justify-center">
                <div className="flex flex-col w-[550px] h-full items-center justify-center text-[#000000] gap-14 text-[16px] ">
                    <img
                        className="w-full h-full rounded object-cover z-10"
                        src={cert_it}
                        alt="Свидетельство о регистрации ЭВМ"
                    />
                </div>
                <div className="flex flex-col w-[550px] h-full items-center justify-center text-[#000000] gap-14 text-[16px] ">
                    <img
                        className="w-full h-full rounded object-cover z-10"
                        src={residentTP}
                        alt="Свидетельство о резидентстве ООО «Технологии Закупок»"
                    />
                </div>
            </div>
            <div className="flex flex-row w-full h-full gap-10 items-center justify-start">
                Основной код ОКВЭД: 62.01 Разработка компьютерного программного
                обеспечения
            </div>
            <div className="flex flex-row w-full h-full gap-10 items-center justify-start">
                Код вида деятельности по приказу Минцифры от 11.05.2023 № 449:
                1.01 Проектирование, и (или) обследование, и (или) разработка, и
                (или) адаптация, и (или) модификация (в том числе локализация,
                кастомизация, доработка), и (или) обратное проектирование
                (реверсивный инжиниринг), и (или) модернизация, и (или)
                обновление, и (или) установка, и (или) интеграция, и (или)
                настройка, и (или) конфигурирование, и (или) внедрение, и (или)
                сопровождение, и (или) тестирование, и (или) испытания, и (или)
                техническая поддержка, и (или) эксплуатация, включая
                администрирование, а также оказание услуг (в том числе
                консультационных, услуг по обучению, экспертных услуг и иных) в
                указанных видах деятельности (далее - проектирование и (или)
                иная деятельность, а также оказание услуг), в отношении программ
                для электронных вычислительных машин (далее - программы для
                ЭВМ), и (или) баз данных (в том числе их обновлений и
                исправлений), и (или) визуальных пользовательских интерфейсов
            </div>
            <div className="flex flex-row w-full h-full gap-10 items-center justify-start">
                Технологический стек: Python, TypeScript, PostgreSQL
            </div>
        </div>
    )
}

export default CompanyDocsPage
